import Vue from "vue";
import Router from "vue-router";
import HomeRoutes from "./views/pages/Home/routes";

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  mode: "hash",
  routes: [
    {
      path: "/",
      ...HomeRoutes,
    },
  ],
});

export default router;
